import { useState, useEffect, useRef } from "react";
import { jwtFetch } from "./utils/apiClient";
import { sortTableRows } from "./utils/tableSort";
import { config, encodeBase64RequestBody } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const Contact = () => {
  const [contacts, setContacts] = useState(null);
  const [tableSearch, setTableSearch] = useState('');
  const [tableSortBy, setTableSortBy] = useState('cperson_name');
  const [tableSortType, setTableSortType] = useState('ascending');
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const searchInputRef = useRef(null);

  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  useEffect(() => {
    getContacts();
  }, []);

  const getContacts = async () => {
    try {
      const requestContacts = {}
      const fetchContacts = await jwtFetch(config.ENDPOINT + 'get/contact_person', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestContacts)
      });
      const responseContacts = await fetchContacts.json();
      if (responseContacts.status === 200) {
        for (let i in responseContacts.data) {
          let searchData = responseContacts.data[i].cperson_name?.toLowerCase() || '';
          searchData += responseContacts.data[i].cperson_email?.toLowerCase() || '';
          searchData += responseContacts.data[i].cperson_phone?.toLowerCase() || '';
          searchData += responseContacts.data[i].cperson_position?.toLowerCase() || '';
          searchData += responseContacts.data[i].company_name?.toLowerCase() || '';
          searchData += responseContacts.data[i].subcompany_name?.toLowerCase() || '';
          responseContacts.data[i].search = searchData;
        }
        setContacts(responseContacts.data);
        setIsLoadingPage(false);
      } else {
        alert(responseContacts.message);
      }
    } catch (error) {
      console.error('Error in getContacts:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const sortTable = (sortBy) => {
    if (tableSortBy === sortBy) {
      setTableSortType(tableSortType === 'ascending' ? 'descending' : 'ascending');
    } else {
      setTableSortBy(sortBy);
      setTableSortType('ascending');
    }
  }

  const clearSearch = () => {
    setTableSearch('');
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }

  return (
    <div id="contact-list">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="client" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center justify-content-between gap-4">
                      <div className="fs-24">Client List</div>
                      <div className="btn-group" role="group">
                        <button className="btn btn-secondary" type="button" onClick={() => window.location.href = '/client'}><i className="bi bi-building me-1" /> Company Groups</button>
                        <button className="btn btn-secondary" type="button" onClick={() => window.location.href = '/client/subsidiary'}><i className="bi bi-buildings me-1" /> Subsidiaries</button>
                        <button className="btn bg-gold" type="button"><i className="bi bi-people me-1" /> Contacts</button>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <div className="input-group input-search">
                        <button className="btn bg-white" type="button" onClick={() => clearSearch()}>{tableSearch ? <i className="bi bi-x-lg" /> : <i className="bi bi-search" />}</button>
                        <input className="form-control" type="text" placeholder="Search" value={tableSearch} onChange={(e) => setTableSearch(e.target.value)} ref={searchInputRef} autoFocus />
                      </div>
                      {(crmUser.user_department !== 'Sales Admin' && crmUser.user_level !== 'View') && (
                        <button className="btn btn-link bg-gold" type="button" onClick={() => window.location.href = '/client/contact/add'}><i className="bi bi-plus-circle me-1" /> Add</button>
                      )}
                    </div>
                  </div>
                  <div className="bg-white border-radius-4 p-4">
                    {contacts && contacts.length ? (
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th className="bg-gold">#</th>
                              <th className="bg-gold pointer text-start" onClick={() => sortTable('cperson_name')}>Name {tableSortBy === 'cperson_name' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold pointer text-start" onClick={() => sortTable('company_name')}>Company Group {tableSortBy === 'company_name' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold pointer text-start" onClick={() => sortTable('subcompany_name')}>Subsidiary {tableSortBy === 'subcompany_name' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              {/* <th className="bg-gold pointer text-start" onClick={() => sortTable('cperson_email')}>Email {tableSortBy === 'cperson_email' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2"/> : <span className="bi bi-sort-up-alt ms-2"/>)}</th> */}
                              {/* <th className="bg-gold pointer text-start" onClick={() => sortTable('cperson_phone')}>Phone {tableSortBy === 'cperson_phone' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2"/> : <span className="bi bi-sort-up-alt ms-2"/>)}</th> */}
                              <th className="bg-gold pointer text-start" onClick={() => sortTable('cperson_position')}>Position {tableSortBy === 'cperson_position' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {sortTableRows(contacts, tableSortBy, tableSortType === 'ascending')
                              .filter(contact => (contact.search || '').includes((tableSearch || '').trim().toLowerCase()))
                              .map((contact, c) =>
                                <tr key={"contact-" + c}>
                                  <td valign="middle">{c + 1}</td>
                                  <td valign="middle">
                                    <strong>{contact.cperson_name}</strong>
                                    <br />
                                    <small>{contact.cperson_email}</small>
                                  </td>
                                  <td valign="middle">{contact.company_name}</td>
                                  <td valign="middle">{contact.subcompany_name}</td>
                                  {/* <td valign="middle">{contact.cperson_name}</td>
                                <td valign="middle">{contact.cperson_email}</td> */}
                                  {/* <td valign="middle">{contact.cperson_phone}</td> */}
                                  <td valign="middle">{contact.cperson_position}</td>
                                  <td valign="middle" align="right"><button className="btn btn-sm bg-gold" onClick={() => window.location.href = '/client/contact/detail/' + contact.id_contact_person}><i className="bi bi-eye" /></button></td>
                                </tr>
                              )}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <p>{isLoadingPage ? 'Loading...' : 'No data'}</p>
                    )}
                  </div>
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;

